




import { Vue, Component } from 'vue-property-decorator';
import BookingComponent from '@/components/common/BookingComponent.vue';
import { getBooking } from '@/api/api';
import formatCustomer from '@/utils/formatCustomer';

@Component({
    beforeRouteEnter: async (to, from, next) => {
        try {
            const resp = await getBooking(+to.params.bookingID);
            const booking = resp.data;

            if (booking.customer) {
                to.meta.breadcrumb[2].title = formatCustomer(booking.customer);
            }
        } catch (error) {
            if (error.response.status == 404) {
                Vue.prototype.$vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: `Réservation introuvable.`,
                });

                next({
                    name: 'bookings',
                });
                return;
            }
        }

        next();
    },
    components: {
        BookingComponent,
    },
})
export default class BookingAdmin extends Vue {}
